import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FEATURE_ONEPORTAL } from '../../../../constants';
import { TutorialStepDefinition } from '../TutorialStep';
import { useManualStep } from '../useManualStep';

const STEP_ID = 'informEmployees';

export function useInformEmployeesStep(): TutorialStepDefinition {
  const { t } = useTranslation('tutorialModule');
  const manualStepProps = useManualStep(STEP_ID);

  return useMemo(
    () => ({
      ...(t(FEATURE_ONEPORTAL ? 'steps.informEmployeesWithBls' : 'steps.informEmployees', { returnObjects: true }) as {
        label: string;
        description: string;
        help: string;
        buttonText: string;
      }),
      ...manualStepProps,
    }),
    [manualStepProps, t],
  );
}
